import { FTL_WEB_APP } from 'app/commons/constants'

import { deleteAllStorage } from '..'
import axios from './axios.helper'

export const handleApiError = async (err) => {
  if (err && err.status === 401) {
    const response = await axios.delete(`${FTL_WEB_APP}/api/v3/customers/sign_out`)
    if (response.status === 204) {
      deleteAllStorage()
      window.location.replace('/')
    }
  }
  if (typeof err.data === 'string' || err.data instanceof String) return { error: err.data, status: err.status }

  return { ...err.data, status: err.status }
}
